// extracted by mini-css-extract-plugin
export var chip = "_mj-0";
export var icon = "_mj-1";
export var remove = "_mj-2";
export var removeIcon = "_mj-3";